import { z } from "zod";
import { Form } from "src/components/common/form";
import { Input } from "src/components/common/form/input";
import { usePostBusRouteMutation } from "src/services/react-query-apis/post-bus-route";
import { usePutBusRouteMutation } from "src/services/react-query-apis/put-bus-route";
import { toast } from "react-toastify";

const routeEditInputSchema = z.object({
  stop_name: z.string().min(1, { message: "停留所名を入力してください" }),
  time_from_start: z
    .string()
    .regex(/^[0-9]{2}:[0-9]{2}:[0-9]{2}$/, {
      message: "時間はhh:mm:ssの形式で入力してください",
    })
    .min(1, { message: "始点からの時間を入力してください" }),
});

const BusRouteEditForm = ({
  selectedCourse,
  selectedRoute,
  formSubmitRef,
  setSelectedRouteId,
}) => {
  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      setSelectedRouteId(data.data.id);
    },
  };

  const postBusRouteMutation = usePostBusRouteMutation({
    mutationConfig,
  });

  const putBusRouteMutation = usePutBusRouteMutation({
    mutationConfig,
  });

  return (
    <div className="mt-4">
      <h5>バス停情報</h5>
      <Form
        onSubmit={values => {
          if (selectedRoute?.id) {
            putBusRouteMutation.mutate({
              courseId: selectedCourse?.id,
              routeId: selectedRoute?.id,
              ...values,
            });
          } else {
            postBusRouteMutation.mutate({
              courseId: selectedCourse?.id,
              ...values,
            });
          }
        }}
        options={{
          defaultValues: {
            stop_name: selectedRoute?.stop_name || "",
            time_from_start: selectedRoute?.time_from_start || "",
          },
        }}
        schema={routeEditInputSchema}
      >
        {({ register, formState }) => {
          return (
            <>
              <div className="d-flex gap-2 mb-3">
                <div style={{ flex: 1 }}>
                  <Input
                    type="text"
                    label="停留所名"
                    name="stop_name"
                    error={formState.errors["stop_name"]}
                    registration={register("stop_name")}
                  />
                </div>
                <div className="w-25">
                  <Input
                    type="text"
                    label="始点からの時間(分)"
                    name="time_from_start"
                    error={formState.errors["time_from_start"]}
                    registration={register("time_from_start")}
                  />
                </div>
                <button
                  type="submit"
                  ref={formSubmitRef}
                  style={{ display: "none" }}
                >
                  追加
                </button>
              </div>
            </>
          );
        }}
      </Form>
    </div>
  );
};

export default BusRouteEditForm;
